window.addEventListener('DOMContentLoaded', () => {
    stickyHeader();
    overlayForNavbar();
})

function overlayForNavbar() {
    const navbar = document.getElementsByClassName("navbar__menu-links")[0];
    const overlay = document.getElementById("overlay");
    if (navbar && overlay) {
        navbar.addEventListener("mouseover", () => {
            if (window.innerWidth > 1023) {
                overlay.style.display = "block";
            }
        })
        navbar.addEventListener("mouseleave", () => {
            if (window.innerWidth > 1023) {
                overlay.style.display = "none";
            }
        })
    }
}

function stickyHeader() {
    const headerElement = document.getElementById("header");
    const pageTopBanner = document.getElementById("pageTopBanner");
    if (headerElement) {
        if (window.scrollY > 96) {
            headerElement.classList.add("stickyHeader");
        }
        document.addEventListener("scroll", () => {
            if (window.scrollY > 96) {
                headerElement.classList.add("stickyHeader");
            } else {
                headerElement.classList.remove("stickyHeader");
            }
        })
        if (!pageTopBanner) {
            headerElement.classList.add("headerNoHero");
        } else {
            headerElement.classList.add("headerlogo2");
        }
    }
}